export default "/images/88d3b51b56b2b5a17bd8e15dbda11d49.avif";